import * as React from 'react'
import { styleguide } from 'styleguide'

export default props => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 100 100"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}>
    <g
      id="survey-icon-Desktop-Copy-3"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g id="survey-icon-Group-43">
        <rect
          id="survey-icon-Rectangle-18"
          fill={styleguide.colors.background}
          x="0"
          y="27"
          width="100"
          height="73"
        />
        <g
          id="survey-icon-Group-41"
          transform="translate(12.000000, 40.000000)">
          <g
            id="survey-icon-Group-40"
            transform="translate(0.000000, 14.000000)">
            <circle
              id="survey-icon-Oval"
              fill={styleguide.colors.secondary}
              cx="5.5"
              cy="5.5"
              r="5.5"
            />
            <g
              id="survey-icon-Group-39"
              transform="translate(24.000000, 4.000000)"
              stroke={styleguide.colors.foreground}
              stroke-linecap="square"
              stroke-width="3">
              <path d="M1,1.5 L48.0022935,1.5" id="survey-icon-Line-4" />
            </g>
          </g>
          <g id="survey-icon-Group-40">
            <circle
              id="survey-icon-Oval"
              fill={styleguide.colors.secondary}
              cx="5.5"
              cy="5.5"
              r="5.5"
            />
            <g
              id="survey-icon-Group-39"
              transform="translate(24.000000, 4.000000)"
              stroke={styleguide.colors.foreground}
              stroke-linecap="square"
              stroke-width="3">
              <path d="M1,1.5 L48.0022935,1.5" id="survey-icon-Line-4" />
            </g>
          </g>
          <g
            id="survey-icon-Group-40"
            transform="translate(0.000000, 28.000000)">
            <circle
              id="survey-icon-Oval"
              fill={styleguide.colors.secondary}
              cx="5.5"
              cy="5.5"
              r="5.5"
            />
            <g
              id="survey-icon-Group-39"
              transform="translate(24.000000, 4.000000)"
              stroke={styleguide.colors.foreground}
              stroke-linecap="square"
              stroke-width="3">
              <path d="M1,1.5 L48.0022935,1.5" id="survey-icon-Line-4" />
            </g>
          </g>
        </g>
        <rect
          id="survey-icon-Rectangle-17"
          fill={styleguide.colors.primary}
          x="0"
          y="0"
          width="100"
          height="27"
        />
        <path
          d="M1.49871137,26 L98.501269,26"
          id="survey-icon-Line-6"
          stroke="#FFC148"
          stroke-width="3"
          stroke-linecap="square"
        />
      </g>
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/components/Sections/HowItWorks/Icon/SurveySvg.jsx